import { CmdbUser, ServerAPIResponse, TepngUser } from "../helpers/interfaces"
import { callServerAPI, showBackDrop } from "../helpers/utils"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { enqueueSnackbar } from "notistack";
const MySwal = withReactContent(Swal);

export const getAllCMDBUsers = async () => {
    return await new Promise<CmdbUser[]>(async (resolve, reject) => {
        callServerAPI<ServerAPIResponse<CmdbUser[]>>('GET', '/api/v1/Users/CMDBUsers?Page=1&PageSize=5000&OrderBy=Descending&SearchString=&api-version=1', null, true)
            .then(response => {
                resolve(response.data.data)
            })
    })
}

export const getAllUserProfiles = async () => {
    return await new Promise<TepngUser[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading User Profiles"));
        callServerAPI<ServerAPIResponse<TepngUser[]>>('GET', '/api/v1/Users?Page=1&PageSize=10&OrderBy=Ascending&SearchString=&api-version=1', null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}
export async function createUserProfile(email: string, isAdmin: boolean) {
    const userData ={email, isAdmin}
    return await new Promise<TepngUser>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Creating new User Profile"));
        callServerAPI<ServerAPIResponse<TepngUser>>('POST', `/api/v1/Users?api-version=1`, userData, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("User Profile Created", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function updateUserProfile(id: string, isAdmin: boolean) {
    return await new Promise<TepngUser>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Updating User Profile"));
        callServerAPI<ServerAPIResponse<TepngUser>>('PATCH', `/api/v1/Users/UpdateRole?UserId=${id}&IsAdmin=${isAdmin}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("User Profile Updated", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export async function DisableUser(id: string) {
    return await new Promise<TepngUser>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("User is being  Disabled"));
        callServerAPI<ServerAPIResponse<TepngUser>>('PATCH', `/api/v1/Users/Disable?UserId=${id}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("User has been disabled", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}
export async function EnableUser(id: string) {
    return await new Promise<TepngUser>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("User is being  Enabled"));
        callServerAPI<ServerAPIResponse<TepngUser>>('PATCH', `/api/v1/Users/Enable?UserId=${id}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar("User has been enabled", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}